import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {useQuery} from "@tanstack/react-query";
import placeService from "../../../../services/web/place-service.js";
import Loader from "../../../../components/template/loader.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const {data: places = [], isLoading: isLoadingPlaces} = useQuery({
        queryFn: placeService.placeNames,
        queryKey: ['places']
    })

    return (
        <>
            {isLoadingPlaces && <Loader/>}
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>
                    <div>
                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>
                    <div>
                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>
                    <div>
                        <SelectComponent
                            instanceId="places"
                            label="Local pré-cadastrado"
                            options={places}
                            isMulti={true}
                            value={places.filter(el => filters.places.includes(el))}
                            onChange={selected => setFilters(prev => ({...prev, places: selected}))}
                        />
                    </div>
                    <AccessForm setFilters={setFilters} filters={filters} />
                </form>
            </div>
        </>
    );
};

export default Filters;